<template>
  <div id="ModifyContactPerson">
    <div class="navBars">
      <img src="../assets/leftRun.png" @click="goback">
      <p>编辑</p>
    </div>
    <div class="zidingyi">
      <div><p>备注名</p><p><van-field class="van-fieldWrap" v-model="getData.remark" /></p></div>
      <div>
        <p>国家</p>
        <p>
          <span>{{ getData.countryname }}</span>
          <img src="../assets/run.png" @click="guojiashowFn"></p>
      </div>
      <div>
        <p>手机号</p>
        <div class="spDiv">
          <span v-show="getData.mobileareacode">+ {{ getData.mobileareacode }}</span>
          <img src="../assets/vector.png" @click="showPickerFn" style="margin: 0 10px;">
          <!-- <van-picker title=“标题” :columns='countrycodeselector' :colunmsFieldNames="{text:'name'}"/> -->
          <!-- <select class="myslect" v-model="getData.mobileareacode" filterable placeholder="请选择" size="small">
            <option v-for="item in countrycodeselector" :key="item.index" :label="item.label + item.value" :value="item.value"></option>
          </select> -->
          <van-field class="van-fieldWrap" v-model="getData.mobile" />
        </div>
      </div>
      <div><p>邮箱</p><p><van-field class="van-fieldWrap" v-model="getData.email" /></p></div>
      <div><p>公司</p><p><van-field class="van-fieldWrap" v-model="getData.companyname" /></p></div>
      <div>
        <p>标签</p>
        <div style="display: flex;justify-content: space-between !important;align-items: center;">
          <div class="tagWraps">
            <van-tag v-for="item in getData.TagAll" :key="item.Id" type="info">{{ item.name }}</van-tag>
          </div>
          <img src="../assets/run.png" @click="showTagFn">
        </div>
      </div>
      <div><p>负责人</p><p>{{ fuzeren }}</p></div>
      <van-button type="info" size="middle" class="addbtn" @click="WhatsAppCustomerTelephonesUpdateFn">保存</van-button>
    </div>
    <!-- <van-action-sheet v-model="guojiashow" :actions="allCountry" :close-on-click-action="true" @select="onSelect" /> -->
    <van-action-sheet v-model="guojiashow" :close-on-click-action="true">
      <div class="mysheet">
        <van-search class="searchWraps" v-model="searchValue" placeholder="搜索" @input="listchat"/>
        <div :class="{lan : activeName === action.name}" id="countryItem" v-for="action in allCountry" :key="action.name" @click="actionFn(action)">
          {{ action.name }}
        </div>
      </div>
    </van-action-sheet>
    <van-popup class="TagDialog" v-model="showTag">
      <div class="fanyidialogitem1"><span>设置标签</span><img src="../assets/guanbi.png" @click="showTag = false"></div>
      <div class="tagsWraps">
        <van-tag :type="chkedAry.indexOf(item.Id) !== -1 ? 'info' : ''"  v-for="item in magg" :key="item.Id" @click="checkedTagFn(item)">{{ item.Name }}</van-tag>
      </div>
      <div class="jjWraps">
        <van-button type="info" size="small" @click="backFn">确定</van-button>
        <van-button size="small" style="margin-left: 20px;" @click="SheZhiBiaoQianClear">重置</van-button>
      </div>
    </van-popup>
    <!-- <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="countrycodeselector" value-key="label2" @cancel="hideshowPicker" @confirm="changecountrycodeselector"/>
    </van-popup> -->
    <van-action-sheet v-model="showPicker" :close-on-click-action="true">
      <van-search class="searchWraps" v-model="searchValue2" placeholder="搜索" @input="listchat2"/>
      <div class="mysheet">
        <div :class="{lan : activeName2 === action.label}" id="countryItem" v-for="action in countrycodeselector" :key="action.name" @click="actionFn2(action)">
          {{ action.label2 }}
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import { Toast } from 'vant-green'
import {WhatsAppTagList, WhatsAppCustomerTelephonesUpdate} from '../http/api'
import zhongMao from '../script/zhongMao'
// import countryCodeSelector from 'vue-country-diacode-selector'
import templateLanguagesObject from '../assets/templateLanguages/templateLanguages'
export default {
  // components: {countryCodeSelector},
  data () {
    return {
      activeName: '',
      activeName2: '',
      searchValue: '',
      searchValue2: '',
      chkedAry: [],
      showPicker: false,
      getData: {},
      fuzeren: '',
      allCountry: zhongMao,
      guojiashow: false,
      showTag: false,
      oldmagg: [],
      magg: [],
      WhatsAppCustomerTelephonesUpdateData: {
        CustomerTelephoneId: 0,
        Remark: '',
        MobileAreaCode: '',
        Mobile: '',
        CompanyName: '',
        CountryCode: '',
        Email: '',
        TagIdList: []
      },
      countrycodeselector: [],
      topTagList: []
    }
  },
  methods: {
    onConfirm () {},
    onChange () {},
    onSelect (item) {
      this.getData.countryname = item.name
      this.activeName = item.name
      this.getData.countrycode = item.code
      console.log(item)
    },
    showTagFn () {
      let _this = this
      console.log(this.getData.TagAll)
      this.chkedAry = []
      this.getData.TagAll.forEach(function (item) {
        _this.chkedAry.push(item.Id)
      })
      this.showTag = true
    },
    massageList () {
      const data = {
        Keyword: '',
        PageIndex: 1,
        Module: 1,
        PageSize: 1000
      }
      // this.biaoqianloading = true
      WhatsAppTagList(data, 'has').then(response => {
        this.biaoqianloading = false
        if (response.code === 200 && response.result && response.result.length > 0) {
          response.result.forEach(res => {
            res.status = false
            res.clickType = 'add'
          })
          this.oldmagg = JSON.parse(JSON.stringify(response.result.reverse()))
          this.magg = JSON.parse(JSON.stringify(response.result.reverse()))
        }
      })
    },
    WhatsAppCustomerTelephonesUpdateFn () {
      let _this = this
      this.WhatsAppCustomerTelephonesUpdateData.CustomerTelephoneId = this.getData.id
      this.WhatsAppCustomerTelephonesUpdateData.Remark = this.getData.remark
      this.WhatsAppCustomerTelephonesUpdateData.MobileAreaCode = this.getData.mobileareacode
      this.WhatsAppCustomerTelephonesUpdateData.Mobile = this.getData.mobile
      this.WhatsAppCustomerTelephonesUpdateData.CompanyName = this.getData.companyname
      this.WhatsAppCustomerTelephonesUpdateData.CountryCode = this.getData.countrycode
      this.WhatsAppCustomerTelephonesUpdateData.Email = this.getData.email

      this.WhatsAppCustomerTelephonesUpdateData.TagIdList = []
      this.topTagList.forEach(item => {
        _this.WhatsAppCustomerTelephonesUpdateData.TagIdList.push(item.Id)
      })
      console.log(this.WhatsAppCustomerTelephonesUpdateData)
      WhatsAppCustomerTelephonesUpdate(this.WhatsAppCustomerTelephonesUpdateData, 'has').then(response => {
        if (response.code === 200) {
          Toast('操作成功')
          let oldMsgs = JSON.parse(localStorage.getItem('userMsg'))
          oldMsgs.remark = this.getData.remark
          oldMsgs.countrycode = this.getData.countrycode
          oldMsgs.countryname = this.getData.countryname
          oldMsgs.mobileareacode = this.getData.mobileareacode
          oldMsgs.mobile = this.getData.mobile
          oldMsgs.email = this.getData.email
          oldMsgs.companyname = this.getData.companyname
          oldMsgs.TagAll = this.getData.TagAll
          localStorage.setItem('userMsg', JSON.stringify(oldMsgs))
        }
      })
    },
    actionFn2 (value) {
      this.getData.mobileareacode = value.value
      this.activeName2 = value.label
      this.showPicker = false
      // picker.setColumnValues(1, citys[values[0]]);
    },
    checkedTagFn (item) {
      if (this.chkedAry.indexOf(item.Id) === -1) {
        this.chkedAry.push(item.Id)
      } else {
        this.chkedAry.splice(this.chkedAry.indexOf(item.Id), 1)
      }
    },
    SheZhiBiaoQianClear () {
      this.chkedAry = []
    },
    backFn () {
      // this.oldTagList = JSON.parse(JSON.stringify(this.topTagList))
      this.topTagList = []
      for (let a = 0; a < this.magg.length; a++) {
        if (this.chkedAry.indexOf(this.magg[a].Id) !== -1) {
          let kong = {}
          kong.name = this.magg[a].Name
          kong.Id = this.magg[a].Id
          this.topTagList.push(kong)
        }
      }
      this.getData.TagAll = this.topTagList
      console.log(this.topTagList)
      this.showTag = false
    },
    hideshowPicker () {
      this.showPicker = false
    },
    goback () {
      history.go(-1)
    },
    actionFn (action) {
      this.getData.countryname = action.name
      this.getData.countrycode = action.code
      this.activeName = action.name
      this.allCountry = zhongMao
      this.guojiashow = false
    },
    listchat () {
      console.log(this.allCountry)
      if (this.searchValue.length === 0) {
        this.allCountry = zhongMao
      } else {
        let newAry = []
        var reg = /[\u4e00-\u9fa5]/g
        if (reg.test(this.searchValue)) {
          this.allCountry.forEach(item => {
            if (item.name.indexOf(this.searchValue) !== -1) {
              newAry.push(item)
            }
          })
        } else {
          this.allCountry.forEach(item => {
            let ft = this.searchValue.toLocaleUpperCase()
            if (item.code.indexOf(ft) !== -1) {
              newAry.push(item)
            }
          })
        }
        this.allCountry = newAry
      }
    },
    guojiashowFn () {
      this.searchValue = ''
      this.allCountry = []
      this.allCountry = zhongMao
      this.guojiashow = true
    },
    listchat2 () {
      let _this = this
      if (this.searchValue2.length === 0) {
        let aad = templateLanguagesObject.countrycodeselector
        aad.forEach(function (item) {
          item.label2 = item.label + item.value
        })
        this.countrycodeselector = aad
      } else {
        let newAry = []
        var reg = /[\u4e00-\u9fa5]/g
        if (reg.test(this.searchValue2)) {
          this.countrycodeselector.forEach(item => {
            if (item.label.indexOf(_this.searchValue2) !== -1) {
              newAry.push(item)
            }
          })
        } else {
          console.log(this.countrycodeselector)
          this.countrycodeselector.forEach(item => {
            let ft = _this.searchValue2 + ''
            let strValue = item.value + ''
            if (strValue.indexOf(ft) !== -1) {
              newAry.push(item)
            }
          })
        }
        this.countrycodeselector = newAry
      }
    },
    showPickerFn () {
      let aad = templateLanguagesObject.countrycodeselector
      this.searchValue2 = ''
      aad.forEach(function (item) {
        item.label2 = item.label + item.value
      })
      this.countrycodeselector = aad
      this.showPicker = true
    }
  },
  mounted () {
    let aad = templateLanguagesObject.countrycodeselector
    aad.forEach(function (item) {
      item.label2 = item.label + item.value
    })
    this.countrycodeselector = aad
    this.guojiashow = false
    let datas = JSON.parse(localStorage.getItem('userMsg'))
    console.log(datas)
    if (datas) {
      this.getData = datas
    }
    this.fuzeren = localStorage.getItem('fuzeren')
    this.massageList()
  }
}
</script>

<style>

</style>

<style scoped>
.navBars{color: #303133;font-weight: bold;font-size: 16px;padding: 14px 10px !important;display: flex;align-items: center;border-bottom: 1px solid #E1E5ED;}
.navBars>div>span{margin: 0 8px;}
.navBars img{cursor: pointer;margin-right: 14px;}
#ModifyContactPerson{background-color: #F2F4F7;}
#ModifyContactPerson>div{padding: 10px 4%;background-color: #fff;}
h4{font-size: 16px;color: #303133;font-weight: bold;}
#ModifyContactPerson>div>div{margin-top: 8px;border-bottom: 1px solid #E1E5ED;padding-bottom: 10px;}
#ModifyContactPerson>div>div>p:nth-child(1){color: #919499;margin-bottom: 4px;}
#ModifyContactPerson>div>div>p:nth-child(2){color: #333;display: flex;align-items: center;justify-content: space-between;margin-top: 6px;}
.zidingyi{margin-top: 16px;}
.addbtn{width: 100%;margin: 20px auto 10px;display: block;}
.TagDialog{width: 90%;margin: 0 auto;max-height: 80%;border-radius: 4px;}
.spDiv{display: flex;align-items: center;}
.spDiv>span{flex-shrink: 0;font-size: 16px !important;margin-right: 8px;color: #111;}
.myslect{width: 100%;font-size: 16px;}
.myslect option{width: 100%;font-size: 16px;}
.fanyidialogitem1{display: flex;justify-content: space-between;align-items: center;padding: 8px 0;color: #333;font-weight: bold;font-size: 14px;margin-top: 0 !important;}
.fanyidialogitem2>p{color: #919499;margin: 14px 0 6px 0;}
.fanyidialogitem2>section{padding: 8px 14px;background-color: #F2F4F7;border-radius: 4px;display: flex;align-items: center;justify-content: space-between;}
.tagsWraps{padding: 0 2%;border-bottom: 0 !important;margin-top: 12px !important;}
.tagsWraps>span{margin:0 8px 8px 0;cursor:pointer}
.tagWraps>span{margin: 0 10px 4px 0;}
.jjWraps{display: flex;align-items: center;border-bottom: 0 !important;}
.jjWraps>button{flex: 1;}
#countryItem{padding: 6px 0;text-align: center;}
.kongWrap{height: 40px;}
.searchWraps{width:100%;position: fixed;bottom: 60%;left: 0;}
.lan{color: #4662D9 !important;}
.van-action-sheet{height: 60% !important;}
.van-action-sheet__content{border-bottom: 0 !important;}
</style>



// WEBPACK FOOTER //
// src/view/ModifyContactPerson.vue